import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/Redux/RootReducer';
import { selectorUtils } from '@/Utils';

const shippingLabelModalState = (state: RootState) => state.modalWindows.shippingLabelModalState;

const loadingState = createSelector(shippingLabelModalState, (state) => state.loadingType);

const isLoaded = selectorUtils.createIsLoadedSelector(loadingState);

const validationConflicts = createSelector(shippingLabelModalState, (state) => state.validationConflicts);

const validationConflictsCount = createSelector(validationConflicts, (conflicts) => conflicts.length);

const currentShippingLabelStep = createSelector(shippingLabelModalState, (state) => state.currentStep);

const isEditing = createSelector(shippingLabelModalState, (state) => state.isEditing);

const orderWarehouseInfos = createSelector(shippingLabelModalState, (state) => state.orderWarehouseInfos);

const currentValidationConflictIndex = createSelector(shippingLabelModalState, (state) => state.currentConflictIndex);

const filteredOrderIdsByWarehouse = createSelector(
  shippingLabelModalState,
  (state) => state.filteredOrderIdsByWarehouse,
);

const currentValidationConflict = createSelector(
  [validationConflicts, currentValidationConflictIndex],
  (conflicts, index) => conflicts?.[index],
);

export const shippingLabelModalSelectors = {
  validationConflicts,
  validationConflictsCount,
  currentValidationConflictIndex,
  currentValidationConflict,
  isLoaded,
  currentShippingLabelStep,
  isEditing,
  orderWarehouseInfos,
  filteredOrderIdsByWarehouse,
};
